import { flow, types as t } from 'mobx-state-tree';

import hlrApi from 'shared/api/hlr';
import { TParams, TParamsLvl3 } from 'shared/api/hlr/types';
import { OptionProviderM } from '../../sms/smsResults';

export const HlrItemLvl1 = t.model('HlrItemLvl1', {
  // Some flags may be missing from API; default to false
  a: t.optional(t.boolean, false),
  created: t.maybeNull(t.string),
  id: t.number,
  // insertion_mode: t.string,
  n: t.optional(t.boolean, false),
  p: t.optional(t.boolean, false),
  provider: t.maybeNull(t.string),
  s: t.optional(t.boolean, false),
  successOnly: t.optional(t.boolean, false),
  pending: t.optional(t.boolean, false),
  count: t.optional(t.number, 0),
  progress: t.maybe(t.number),
  // Accept strict OptionProvider, any frozen array, or any frozen object; allow null
  options: OptionProviderM,
  // Additional fields seen in backend payload
  countries_count: t.optional(t.number, 0),
  mass: t.optional(t.boolean, false),
  sent_by: t.maybeNull(t.string),
  created_date: t.maybeNull(t.string),
  done_date: t.maybeNull(t.string),
  stop_date: t.maybeNull(t.string),
  pause_date: t.maybeNull(t.string),
  status: t.maybeNull(t.number),
  operators_count: t.number,
  gt_count: t.optional(t.number, 0),
  user_count: t.number,
  events_sent: t.union(t.number, t.string),
  events_delivered: t.union(t.number, t.string),
  // Backend sometimes sends numeric user identifiers here; accept string | number | null
  user_name: t.union(t.null, t.string, t.number),
  success_operators: t.union(t.number, t.string),
  smsc: t.maybe(t.union(t.number, t.string)),
  send_mode: t.maybe(t.string),
});

export const HlrResultsModel = t
  .model('HlrResultsModel', {
    refreshSecondLevelData: t.boolean,
    refreshThirdLevelData: t.boolean,
    dataLvl1: t.array(HlrItemLvl1),
    totalLvl1: t.number,
    areAllMessageDetailsVisible: t.boolean,
    smscValue: t.string,
  })
  .actions(self => ({
    setSuccessStatus(i: number, status: boolean) {
      self.dataLvl1[i].successOnly = status;
    },
    getDataLvl1: flow(function* getDataLvl1(params: TParams) {
      const res = yield hlrApi.fetchDataLvl1(params);

      /* Backend may return items as an object keyed by id or as an array;
      normalize to array
       */
      const normalizedItems = Array.isArray(res.items)
        ? res.items
        : Object.values(res.items || {});
      self.dataLvl1 = normalizedItems as any;
      self.totalLvl1 = res.total;
    }),

    setRefreshSecondLevelData(status: boolean) {
      self.refreshSecondLevelData = status;
    },
    getResultsLvl2: flow(function* getDataLvl2(testID, params) {
      return yield hlrApi.fetchDataLvl2(testID, params);
    }),
    getResultsLvl3: flow(function* (
      testID: number,
      operatorID: number,
      params: TParamsLvl3,
    ) {
      return yield hlrApi.fetchDataLvl3(testID, operatorID, params);
    }),
    setRefreshThirdLevelData(status: boolean) {
      self.refreshThirdLevelData = status;
    },
    setAllMessageDetailsVisibility(status: boolean) {
      self.areAllMessageDetailsVisible = status;
    },
    exportResults: flow(function* (id) {
      return yield hlrApi.exportDataHlrResults(id);
    }),
    setSmscValue(value: string) {
      self.smscValue = value;
    },
  }));
